import { titles } from '../../../../web/styles/colors';
import { truncateTextStyle } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	actions: {
		width: 60,
	},
	actionsShift: {
		marginRight: 25,
	},
	checkbox: {
		marginRight: 8,
	},
	container: {
		':last-child': {
			borderBottom: 'none',
		},
		borderBottom: '1px solid #E3E7E9',
		display: 'flex',
		margin: '0 10px',
		padding: '10px 0',
	},
	containerCompact: {
		margin: '0 4px',
		padding: '4px 0',
	},
	created: {
		color: titles,
		fontSize: 12,
		width: 100,
	},
	draft: {
		color: '#C75DA6',
		fontSize: 12,
		marginLeft: 10,
	},
	expired: {
		background: '#e40000',
	},
	expires: {
		background: '#ff8a27',
		borderRadius: 2,
		color: '#ffffff',
		fontSize: 11,
		marginBottom: 4,
		marginLeft: 7,
		marginRight: 4,
		marginTop: 4,
		paddingBottom: 2,
		paddingLeft: 5,
		paddingRight: 5,
		paddingTop: 2,
	},
	gripper: {
		marginTop: 5,
	},
	industries: {
		color: titles,
		fontSize: 12,
		width: 120,
		...truncateTextStyle,
	},
	items: {
		alignItems: 'center',
		display: 'flex',
		flexGrow: 1,
		justifyContent: 'space-between',
	},
	name: {
		alignItems: 'center',
		color: '#046CB6',
		display: 'flex',

		fontSize: 16,
		height: 25,
		marginLeft: 23,
		width: 415,
		...truncateTextStyle,
	},
	socialIcon: {
		marginTop: -10,
	},
});
